// extracted by mini-css-extract-plugin
module.exports = {"Container":"Product_Container__3sTSn","Title":"Product_Title__20RcJ","Summary":"Product_Summary__1JSmh"};